export const SHOP_FILTERS_TO_SHOW = 8;

export const ROW_TO_DISPLAY = 3;

export const SUBCATEGORIES_TO_DISPLAY = 4;
